/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_Categories_ManualInputs */

const vi_shop_home_link_categories_manual = /** @type {(inputs: Shop_Home_Link_Categories_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gõ slug danh mục rồi Enter`)
};

/**

* @param {Shop_Home_Link_Categories_ManualInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_categories_manual = /** @type {((inputs?: Shop_Home_Link_Categories_ManualInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Categories_ManualInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_categories_manual(inputs)
});